// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticleFaq_title__vqd_X","contentContainer":"ArticleFaq_contentContainer__Ox20A"};